import * as React from 'react'
import { ShopifyNext } from '@dotdev/next-components'
import { GlobalProps } from 'types'
import * as Snippets from 'snippets'
import { trackPromotionClick } from 'helpers'

export class FeaturedProducts extends React.PureComponent<FeaturedProducts.Props, FeaturedProducts.State> {
  public static sectionId = 'product';

  public render(): JSX.Element {
    const { section } = this.props
    const { settings, blocks } = section
    const { article } = this.props.data.section

    // Allow full width is used to remove overall parent container width constraints to allow articles to have full width images 
    let allow_full_width_images = article?.settings?.allow_full_width_images

    return (
      <section className={`dynamic-featured-products relative bg-${settings.background} ${allow_full_width_images ? 'max-w-7xl mx-auto' : ''}`}>
        <div className={'max-w-container mx-auto'}>
          <div className={'flex flex-wrap'}>
            <div className={'w-full lg:w-1/2 lg:h-100vh lg:sticky relative top-0'} >
              {settings.image ? 
                <div className={'w-full h-full bg-cover lg:block hidden'} style={{ backgroundImage: `url('${settings.image}')` }}>
                </div>
                : null
              }
              {settings.imagemobile ?
                <div className={'w-full h-full bg-cover relative lg:hidden block'}>
                  <Snippets.Image
                    alt={settings.title || 'featured products image'}
                    ratio={'natural'}
                    src={settings.imagemobile}
                  />
                </div>
                :
                <div className={'w-full h-full bg-cover lg:hidden block'}>
                  <Snippets.Image
                    alt={settings.title || 'featured products image'}
                    ratio={'natural'}
                    src={settings.image}
                  />
                </div>
              }
              <div className={'h-full absolute top-0 left-0 w-full h-full flex lg:translate-x:100 justify-center items-center'}>
                {settings && settings.title ?
                  <Snippets.Heading 
                    tag={'h2'}
                    size={'h1'}
                    className={`px-1-6 mt-20 lg:text-black ${settings.color == 'light' ? 'text-white' : ''} text-center leading-none 
                    lg:w-1/2 w-full`}
                  >
                    {settings.title}
                  </Snippets.Heading>
                  : null }
                {settings.linktext ? (
                  <Snippets.Button 
                    onClick={() => trackPromotionClick(
                      [{
                        id: section.id,
                        name: settings.title,
                        creative: 'Products section'
                      }],
                      settings.linkurl
                    )}
                    className={'mt-2-9 md:mt-3-9 mx-0-3 absolute sticky-link lg:block hidden uppercase font-bold tracking-wider bg-transparent'}
                    title={settings.linktext}
                    colour={'secondary'}
                  >
                    {settings.linktext}
                  </Snippets.Button>
                ) : null}
              </div>
            </div>

            <div className={'w-full lg:w-1/2 lg:px-6 overflow-x-auto hide-scrollbar'}>
              <div className={'lg:block flex w-full'}>
                {blocks
                  ? blocks.map((block: any, i: number) => {
                    const blockImage = block.settings.image
                    return (<div key={i} className={'lg:flex-none flex-1 lg:w-full lg:flex-1 my-2-1 lg:h-100vh md:my-0 lg:pb-12-8 flex justify-center items-center'}>
                      <Snippets.Link
                        onClick={() => trackPromotionClick(
                          [{
                            id: `${section.id}-block-${i}`,
                            name: settings.title,
                            position: block.settings.product.title,
                            creative: 'Products section'
                          }],
                          block.settings.linkurl
                        )}
                        title={block.settings.product.title}
                        noHover
                        className={'block lg:w-full p-2 w-70vw '}
                      >
                        <div className={'mb-1-6 relative xl:px-6 lg:px-2 w-full'}>
                          {block.settings.image ?
                            <Snippets.Image
                              alt={block.settings.product.title || 'featured product image' }
                              ratio={'natural'}
                              src={block.settings.image}
                            />
                            :
                            block.settings.product.images ? 
                              <Snippets.Image
                                alt={block.settings.product.title || 'featured product image' }
                                ratio={'3:2'}
                                src={block.settings.product.images[0].src}
                              /> : null
                          }
                        </div>
                      </Snippets.Link>
                    </div> 
                    )
                  })
                  : null }

              </div>

            </div>
          </div>

          {settings.linktext ? (
            <div className={'lg:hidden flex justify-center items-center pb-6-4 sm:mt-0 mt-4'}>
              <Snippets.Button 
                onClick={() => trackPromotionClick(
                  [{
                    id: section.id,
                    name: settings.title,
                    creative: 'Products section'
                  }],
                  settings.linkurl
                )}
                className={'sticky-link uppercase font-bold tracking-wider bg-transparent'}
                title={settings.linktext}
                colour={'secondary'}
              >
                {settings.linktext}
              </Snippets.Button>
            </div>
          ) : null}
        </div>

      </section>
    )
  }
}

export namespace FeaturedProducts {
  export interface Options extends ShopifyNext.Section<{
    background: any;
    title: string;
    linktext: string;
    color: string;
    linkurl: string;
    image: any;
    imagemobile: any;
  }> {
    block_size: number;
  }
  export interface Props extends GlobalProps {
    section: FeaturedProducts.Options;
  }
  export interface State {}
}
